import React, { useEffect } from 'react';
import './About.css';
import { setPageTitle, pageTitles, pageDescriptions } from '../utils/pageTitle';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    setPageTitle(pageTitles.about, pageDescriptions.about, 'about', language);
  }, [language]);

  const teamMembers = [
    {
      name: t('about.team.ceo.name'),
      role: t('about.team.ceo.role'),
      image: 'images/adel.webp',
      description: t('about.team.ceo.description')
    },
    {
      name: t('about.team.cto.name'),
      role: t('about.team.cto.role'),
      image: 'images/may.webp',
      description: t('about.team.cto.description')
    },
    {
      name: t('about.team.dev.name'),
      role: t('about.team.dev.role'),
      image: 'images/taymor.webp',
      description: t('about.team.dev.description')
    }
  ];

  const values = [
    {
      icon: '🎯',
      title: t('about.values.excellence.title'),
      description: t('about.values.excellence.description')
    },
    {
      icon: '🤝',
      title: t('about.values.partnership.title'),
      description: t('about.values.partnership.description')
    },
    {
      icon: '🌐',
      title: t('about.values.globalReach.title'),
      description: t('about.values.globalReach.description')
    },
    {
      icon: '🔒',
      title: t('about.values.trust.title'),
      description: t('about.values.trust.description')
    }
  ];

  return (
    <div className="about-page">
      <section className="about-hero section">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="page-title">{t('about.pageTitle')}</h1>
            <p className="about-hero-description">
              {t('about.heroDescription')}
            </p>
          </div>
        </div>
      </section>

      <section className="about-story section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="section-title">{t('about.storyTitle')}</h2>
              <p>
                {t('about.storyParagraph1')}
              </p>
              <p>
                {t('about.storyParagraph2')}
              </p>
            </div>
            <div className="story-visual">
              <div className="story-stats">
                <div className="stat">
                  <span className="stat-number">{t('about.stats.projects')}</span>
                  <span className="stat-label">{t('about.stats.projectsLabel')}</span>
                </div>
                <div className="stat">
                  <span className="stat-number">{t('about.stats.clients')}</span>
                  <span className="stat-label">{t('about.stats.clientsLabel')}</span>
                </div>
                <div className="stat">
                  <span className="stat-number">{t('about.stats.experience')}</span>
                  <span className="stat-label">{t('about.stats.experienceLabel')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-values section">
        <div className="container">
          <h2 className="section-title">{t('about.valuesTitle')}</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-team section">
        <div className="container">
          <h2 className="section-title">{t('about.teamTitle')}</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-avatar">
                 <img
                    src={member.image}
                    alt={member.name}
                    className="portfolio-img"
                    style={{"border-radius": "100%"}}
                  /></div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-description">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
